import { render } from "./PlaceOnAxis.vue?vue&type=template&id=5568f22b&scoped=true"
import script from "./PlaceOnAxis.vue?vue&type=script&lang=ts"
export * from "./PlaceOnAxis.vue?vue&type=script&lang=ts"

import "./PlaceOnAxis.vue?vue&type=style&index=0&id=5568f22b&lang=less&scoped=true"
import "./PlaceOnAxis.vue?vue&type=style&index=1&id=5568f22b&lang=less"
script.render = render
script.__scopeId = "data-v-5568f22b"

export default script